import {
  IDashboard,
  IPage,
  PageType,
  createDashboard,
  createPage,
  generatePageGrids,
} from "@dataone/lib";
import { Button, Form, Input, Select } from "antd";
import { useState } from "react";
import { styled } from "styled-components";
import { useMutation } from "@tanstack/react-query";
interface DashboardFormProps {
  handleCancel: () => void;
  handleOnSuccess: (message: string) => void;
}

const DashboardForm = ({
  handleCancel,
  handleOnSuccess,
}: DashboardFormProps) => {
  const { Option } = Select;
  const [selectedTheme, setSelectedTheme] = useState<string>("1");
  const themes = ["1", "2", "3", "4", "5", "6", "7", "8"];
  const { mutate: addDashboard } = useMutation(createDashboard);
  const { mutate: addPage } = useMutation(createPage);
  const handleThemeChange = (key: string) => {
    setSelectedTheme(key);
  };
  const [dashForm] = Form.useForm();
  const handleFormConfirm = (values: IDashboard) => {
    addDashboard(
      { ...values, theme: +selectedTheme },
      {
        onSuccess: (res) => {
          handleOnSuccess(res.message);
        },
      }
    );
  };
  return (
    <StyledDashboardForm>
      <Form layout="vertical" form={dashForm} onFinish={handleFormConfirm}>
        <Form.Item
          rules={[
            {
              whitespace: true,
              required: true,
              message: "Please input the dashboard name",
            },
          ]}
          name="name"
          label={<StyledLabel>Dashboard Name</StyledLabel>}
        >
          <Input maxLength={255} />
        </Form.Item>
        <Form.Item
          name="description"
          rules={[
            {
              whitespace: true,
              required: true,
              message: "Please input the dashboard description",
            },
          ]}
          label={<StyledLabel>Description</StyledLabel>}
        >
          <Input.TextArea />
        </Form.Item>
        <StyledThemeContainer>
          <Form.Item required label={<StyledLabel>Theme</StyledLabel>}>
            <StyledThemesList>
              {themes.map((theme) => {
                return (
                  <Button
                    key={theme}
                    onClick={() => handleThemeChange(theme)}
                    type="link"
                    className={
                      selectedTheme === theme
                        ? "btn-theme btn-selected"
                        : "btn-theme"
                    }
                    icon={
                      <img
                        alt="background"
                        src={`/images/dashboard/cards/themes/theme-dash-${theme}.svg`}
                      />
                    }
                  />
                );
              })}
            </StyledThemesList>
          </Form.Item>
        </StyledThemeContainer>
        <StyledFooterButtons>
          <Button className="cancel-button" onClick={handleCancel}>
            Cancel
          </Button>
          <Button className="ok-button" htmlType="submit">
            OK
          </Button>
        </StyledFooterButtons>
      </Form>
    </StyledDashboardForm>
  );
};

export default DashboardForm;

const StyledFooterButtons = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  .ok-button {
    border-radius: 10px;
    background: #4974f6;
    color: #fff;
    &:hover {
      background: #4974f6;
      color: #fff !important;
    }
  }
  .cancel-button {
    border-radius: 10px;
    background: #eff1fd;
    color: #000;
    border: none;
    &:hover {
      background: #eff1fd;
      color: #000 !important;
      border: none !important;
    }
  }
`;
const StyledDashboardForm = styled.div`
  //width: 400px;
  width: 280px;
  padding: 0px 0px;
  .ant-input {
    display: flex;
    margin-inline: auto;
    border-radius: 10px;
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
    background: #fff;

    &:is(input) {
      height: 40px;
    }

    &:is(textarea) {
      height: 57px;
    }
  }

  .ant-form-item-explain-error {
    font-size: 12px;
  }

  .ant-form-item {
    margin-bottom: 15px !important;
  }
  .ant-form .ant-form-item .ant-form-item-label {
    flex: none !important;
  }
  .ant-form .ant-form-item .ant-form-item-control {
    flex: none !important;
  }
`;
const StyledLabel = styled.div`
  color: #040726;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: -0.27px;
`;
const StyledThemeContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-right: 20px;

  > div {
    display: flex;
    flex-wrap: wrap;

    &:nth-child(1) {
      padding-top: 13px;
    }
  }

  .btn-theme {
    height: 62px;
    margin-left: 30px;
    padding: 0;
    cursor: pointer;

    img {
      width: 45px;
      border: 3px solid #fff;
      border-radius: 50%;
    }

    &.btn-selected img {
      border: 3px solid #fff;
      outline: 2px solid #4974f6;
    }
  }
`;
const StyledThemesList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10%;
`;
